var $3b25696a80a9bfd8$exports = {};
$3b25696a80a9bfd8$exports = {
  "help": "\u0421\u043F\u0440\u0430\u0432\u043A\u0430",
  "info": "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"
};
export { $3b25696a80a9bfd8$exports as default };